import { pick, serverMap } from '@/shared/lib/server-map'
import type { BookingDetail } from '@/shared/api'

export type BookingHistoryEntry = BookingDetail['history'][number]

// Сервер отдаёт СМЫСЛ, палитру выбирает фронт. Токены те же, что у тона строки деталей и события
// переписки: одинаковый смысл красится одинаково во всём приложении.
const NATURE_TOKENS = serverMap({
  confirm: 'var(--st-in)',
  reject: 'var(--st-cancel)',
  neutral: 'var(--ink-3)',
})

// Незнакомый характер — серый: он не обещает ни «сделано», ни «отказ». Характера нет — тоже серый.
const NATURE_FALLBACK = 'var(--ink-3)'

export function historyNatureToken(nature: BookingHistoryEntry['nature']): string {
  return nature === undefined ? NATURE_FALLBACK : pick(NATURE_TOKENS, nature, NATURE_FALLBACK)
}
